import { Component } from '@angular/core';
import { NavController, NavParams, ModalController, Events } from 'ionic-angular';
import { HttpClient } from '../../../services/HttpClient';

import { AddSeminaryPage } from './addSeminary/addSeminary';
import { SeminaryPage } from './seminary/seminary';

@Component({
  selector: 'page-seminars',
  templateUrl: 'seminars.html',
  providers : [HttpClient]
})
export class SeminarsPage {

	seminars;
  searchQuery = '';

  modalCtrl : ModalController;
	
  httpClient : HttpClient;

  events : Events;

  	constructor(public navCtrl: NavController, public navParams: NavParams, httpClient : HttpClient,modalCtrl : ModalController, events : Events) {
  		this.modalCtrl = modalCtrl;
      this.httpClient = httpClient;
      this.events = events;
      this.events.subscribe('addSeminary:done',()=>{
        this.httpCallSeminars('',1000);
      });
      this.events.subscribe('seminary:delete',()=>{
        this.httpCallSeminars('',1000);
      });
      this.events.subscribe('seminary:update',()=>{
        this.httpCallSeminars('',1000);
      });
      this.httpCallSeminars('',1000);
  	}

    onSearch(){
      if(this.searchQuery.length > 0){
        this.httpCallSeminars(this.searchQuery,50);
      }else{
        this.httpCallSeminars(this.searchQuery,1000);
      }
    }

    httpCallSeminars(title_es,max){
      this.httpClient.get('/seminars?title_es='+title_es+'&max='+max,(error,data)=>{
        this.seminars = data.json();
      });
    }

    onClickAdd(){
      this.navCtrl.push(AddSeminaryPage);
    }

    onClickSeminary(seminary){
      this.navCtrl.push(SeminaryPage,{id : seminary.id})
    }
}



// WEBPACK FOOTER //
// ./src/pages/dashboard/seminars/seminars.ts